import React, { useEffect, useCallback } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Package } from 'lucide-react';
import axios from 'axios';
import { useApp } from '../context/AppContext';

const CheckoutResult = ({ success }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t, API, token, clearCart } = useApp();
  
  const sessionId = searchParams.get('session_id');

  const verifyPayment = useCallback(async () => {
    try {
      await axios.get(`${API}/checkout/status/${sessionId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      clearCart();
    } catch (error) {
      console.error('Error verifying payment:', error);
    }
  }, [API, sessionId, token, clearCart]);

  useEffect(() => {
    if (success && sessionId && token) {
      verifyPayment();
    }
  }, [success, sessionId, token, verifyPayment]);

  return (
    <div 
      className="min-h-screen flex items-center justify-center px-4"
      style={{ background: 'radial-gradient(circle at center, #2C1B18 0%, #050505 100%)' }}
    >
      <div className="glass rounded-2xl p-8 md:p-12 max-w-md w-full text-center">
        {success ? (
          <>
            <CheckCircle size={64} className="mx-auto text-green-500 mb-6" />
            <h1 className="font-heading text-3xl text-white mb-4">
              {t('payment_successful')}
            </h1>
            <p className="text-[#A8A29E] mb-8">
              {t('payment_successful_message')}
            </p>
            <div className="space-y-4">
              <Link to="/account/orders" className="btn-primary w-full block">
                <Package size={18} className="inline mr-2" />
                {t('view_orders')}
              </Link>
              <Link to="/home" className="btn-secondary w-full block">
                {t('continue_shopping')}
              </Link>
            </div>
          </>
        ) : (
          <>
            <XCircle size={64} className="mx-auto text-red-500 mb-6" />
            <h1 className="font-heading text-3xl text-white mb-4">
              {t('payment_cancelled')}
            </h1>
            <p className="text-[#A8A29E] mb-8">
              {t('payment_cancelled_message')}
            </p>
            <div className="space-y-4">
              <Link to="/cart" className="btn-primary w-full block">
                {t('return_to_cart')}
              </Link>
              <Link to="/home" className="btn-secondary w-full block">
                {t('continue_shopping')}
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CheckoutResult;
